import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/sign-out`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signOut = {
  post: apiPathFunc(pathBase),
};
